export default timeToSleep => {
  const executor = (resolve, reject) => {
    window.setTimeout(resolve, timeToSleep)
  }
  return new Promise(executor)
}
